module.exports = __webpack_public_path__ + "static/media/PDF_69.af4506e9.pdf";